module.exports = __webpack_public_path__ + "static/img/order_on@2x.77ccde98.png";